import React from 'react';
import { connect } from 'react-redux';
import autoBind from 'auto-bind';
import PropTypes from 'prop-types';
import { loadMokaConfigList } from 'state/mokaConfig/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';
import MokaConfigForm from 'pages/MokaConfig/MokaConfigForm';
import MokaConfigLogModal from 'pages/MokaConfig/MokaConfigLogModal';

export class MokaConfigPage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadMokaConfigList());
  }

  render() {
    const { mokaConfigs } = this.props;
    return (
      <>
        <SemanticToastContainer />
        <h1>Moka Config</h1>
        <br />
        <MokaConfigLogModal />
        <MokaConfigForm data={mokaConfigs} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.config,
});

const pricesPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  feature_display_name: PropTypes.string.isRequired,
  price_per_month: PropTypes.number.isRequired,
});

const discountsPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  discount: PropTypes.number.isRequired,
});

MokaConfigPage.propTypes = {
  mokaConfigs: PropTypes.shape({
    prices: PropTypes.arrayOf(pricesPropTypes),
    discounts: PropTypes.arrayOf(discountsPropTypes),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(MokaConfigPage);
